// Pagina base de CursoDetalle que es la pagina de informacion-tarjetas-cursos
import React from "react";
import FooterPublico from "./FooterPublico";
import "./BasePresentacionCursos.css";

const BasePresentacionCursos = ({ children }) => {
  return (
    <div className="base-presentacion">
      <div className="presentacion-layout">
        <div className="container1">
        <div className="bloque-info">
              <div className="icono-titulo">
                <img src="/logos/iconoOrdenador.png" alt="Curso" className="icono-ilustrado ui-integrated-image" draggable="false" onContextMenu={(e) => e.preventDefault()} />
                <h3>CURSO 100% ONLINE</h3>
              </div>
          </div>
          <p>
            En MartestGo la formación es completamente online, accesible desde cualquier lugar y
            en cualquier momento a través de nuestra plataforma virtual. Solo necesitas conexión a
            internet y un dispositivo, sin desplazamientos ni horarios rígidos.
          </p>
          <div className="bloque-info">
          <img src="/logos/iconoCalendario.png" alt="Curso" className="icono-ilustrado" />
          <h3>PLANIFICACIÓN FLEXIBLE</h3>
          </div>
          <p>
            Te proponemos una estructura organizada del curso para guiarte, pero tú decides cómo
            adaptarla a tu ritmo. Nuestro objetivo es que tengas todo lo necesario para avanzar a tu
            manera, con libertad pero sin perder el rumbo.
          </p>
          <div className="bloque-info">
          <img src="/logos/iconoCheck.png" alt="Curso" className="icono-ilustrado ui-integrated-image" draggable="false" onContextMenu={(e) => e.preventDefault()} />
            <h3>¿QUÉ INCLUYE?</h3>
          </div>

            <div>
               <p>Acceso completo a todos los materiales del curso:</p>
               <ul>
                 <li>Temarios</li>
                 <li>Resumenes</li>
                 <li>Tests de temario</li>
                 <li>Tests de examen</li>
                 <li>Actualizaciones periódicas</li>
               </ul>
               <p>En resumen, todo lo necesario para que puedas conseguirlo.</p>
             </div>
       
          {/*<div className="bloque-info">
          <img src="/logos/iconoCertificado.png" alt="Curso" className="icono-ilustrado ui-integrated-image" draggable="false" onContextMenu={(e) => e.preventDefault()} />
            <h3>¿POR QUÉ PREPARAR TU OPOSICIÓN CON MARTESTGO?</h3>
            </div>
          <p>
            Porque combinamos metodología, tecnología y experiencia para darte las mejores
            herramientas. Queremos que llegues con confianza, seguridad y una preparación sólida
            tanto en lo técnico como en lo emocional. <br />
            Porque estudiar sin perder tiempo en desplazamientos te permite enfocarte en lo
            importante: tu progreso. <br />
            Porque creemos en ti, y estamos aquí para acompañarte hasta lograr tu meta.
          </p>*/ }
        </div>

        <main className="presentacion-main">{children}</main>
      </div>
      <FooterPublico />
    </div>
  );
};

export default BasePresentacionCursos;
